import { getEnvVars } from '@order/utils';

// TODO: review versioning objectives
const { APP_VERSION = `0.0.404` } = getEnvVars();

export const getSgUserAgentHeader = () => ({
  'User-Agent': `sweetgreen/${APP_VERSION}`,
});
